import React from "react";
import { Container } from "@mui/material";
import StorageManagement from "../components/storageComponent/StorageManagement";
import SiteManagement from "../components/storage/sites/SiteManagement";

const ClientStorageManagement: React.FC = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        padding: "0 !important",
        margin: "0 !important",
        maxWidth: "100% !important",
      }}
    >
      {/* <StorageManagement /> */}
      <SiteManagement/>
    </Container>
  );
};

export default ClientStorageManagement;
